var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutomatedReview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.643,
    height: 18.015,
    viewBox: "0 0 15.643 18.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22376",
    "data-name": "Group 22376",
    transform: "translate(-9790.609 343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29063",
    "data-name": "Path 29063",
    d: "M27.988,7.253H24.644a1.635,1.635,0,0,1-1.635-1.635V2.273A.818.818,0,0,1,23.055,2H16.09A1.09,1.09,0,0,0,15,3.09v7.2a5.386,5.386,0,0,1,2.538-.632,5.452,5.452,0,0,1,5.452,5.452,5.375,5.375,0,0,1-.629,2.524h4.824a1.09,1.09,0,0,0,1.09-1.09V7.2A.831.831,0,0,1,27.988,7.253ZM21.9,6.887H17.265a.273.273,0,1,1,0-.545H21.9a.273.273,0,0,1,0,.545Zm0-2.137H17.265a.273.273,0,1,1,0-.545H21.9a.273.273,0,0,1,0,.545Zm4.634,10.68H23.807a.273.273,0,1,1,0-.545h2.726a.273.273,0,0,1,0,.545Zm0-2.137H23.807a.273.273,0,1,1,0-.545h2.726a.273.273,0,0,1,0,.545Zm0-2.134H22.444a.273.273,0,1,1,0-.545h4.089a.273.273,0,0,1,0,.545Zm0-2.137H22.444a.273.273,0,0,1,0-.545h4.089a.273.273,0,0,1,0,.545Z",
    transform: "translate(9777.979 -345)",
    fill: "#170A33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29064",
    "data-name": "Path 29064",
    d: "M47.47,6.711h3.345a.273.273,0,0,0,.194-.463L46.846,2.085a.273.273,0,0,0-.466.191V5.621A1.09,1.09,0,0,0,47.47,6.711Z",
    transform: "translate(9755.151 -345.003)",
    fill: "#170A33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29065",
    "data-name": "Path 29065",
    d: "M11.216,32.09A4.906,4.906,0,1,0,16.123,37,4.906,4.906,0,0,0,11.216,32.09ZM13.362,39a.951.951,0,0,1-.744.357H10.164a.515.515,0,0,1-.5.4h-.79a.515.515,0,0,1-.512-.515V36.1a.512.512,0,0,1,.512-.512h.79a.5.5,0,0,1,.425.229A1.09,1.09,0,0,0,10.565,35v-.85a.883.883,0,0,1,1.739-.174,3.792,3.792,0,0,1,0,1.567h.818a.949.949,0,0,1,.679.273.962.962,0,0,1,.273.684A4.13,4.13,0,0,1,13.362,39Z",
    transform: "translate(9784.3 -366.888)",
    fill: "#170A33"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomatedReview);
export default __webpack_public_path__ + "static/media/AutomatedReview.34ed83b0855c71a07a67b2b21cf1c516.svg";
export { ForwardRef as ReactComponent };